import { render, staticRenderFns } from "./dooryard.vue?vue&type=template&id=aff80214&scoped=true"
import script from "./dooryard.vue?vue&type=script&lang=js"
export * from "./dooryard.vue?vue&type=script&lang=js"
import style0 from "./dooryard.vue?vue&type=style&index=0&id=aff80214&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff80214",
  null
  
)

export default component.exports